<template>
  <section class="empty-state" :aria-label="title">
    <h2>{{ title }}</h2>
    <p>{{ description }}</p>
    <div v-if="$slots.action" class="empty-state-action">
      <slot name="action" />
    </div>
  </section>
</template>

<script>
export default {
  name: "EmptyState",
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.empty-state {
  background-color: #6a72a0;
  border: 5px solid #393d55;
  margin: 1.5rem 10px;
  padding: 2rem 1.5rem;
  text-align: center;
}

.empty-state h2 {
  margin-bottom: 0.5rem;
}

.empty-state p {
  margin: 0 auto;
  max-width: 40rem;
}

.empty-state-action {
  display: flex;
  justify-content: center;
  margin-top: 1.25rem;
}
</style>
